import { render, staticRenderFns } from "./BidFail.vue?vue&type=template&id=5d310598&scoped=true&"
import script from "./BidFail.vue?vue&type=script&lang=js&"
export * from "./BidFail.vue?vue&type=script&lang=js&"
import style0 from "./BidFail.vue?vue&type=style&index=0&id=5d310598&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d310598",
  null
  
)

export default component.exports